// ** Third Party Imports
import styled from 'styled-components'

export const LandingPageLayoutWrapper = styled.div`
	position: relative;
	background: #ecf2f0;
	z-index: 0;
`
